import { Animated } from 'react-native';
export var hideToastHandler = (timeoutRef, dismissDuration, callback) => {
  if (dismissDuration) {
    (timeoutRef === null || timeoutRef === void 0 ? void 0 : timeoutRef.current) && clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      callback();
    }, dismissDuration);
  }
};
export var animateToast = (fadeAnimRef, show, callback) => {
  Animated.timing(fadeAnimRef, {
    toValue: show ? 1 : 0,
    duration: 200,
    useNativeDriver: true
  }).start(() => callback === null || callback === void 0 ? void 0 : callback());
};